<div [ngClass]="isMenuOpen ? 'srp-menu-container menu-close' : 'srp-menu-container menu-open'">
  <mat-icon [matMenuTriggerFor]="menu" [matMenuTriggerRestoreFocus]="false" (onMenuOpen)="toggleMenu()" (onMenuClose)="menuClosed()"
    [ngClass]="isMenuOpen ? 'srp-header-button close-button' : 'srp-header-button open-button'">
    {{ isMenuOpen ? 'close' : 'menu' }}
  </mat-icon>

  <mat-menu #menu="matMenu" class="srp-menu srp-catalog-menu" [hasBackdrop]="true" [overlapTrigger]="false">
    <ng-template matMenuContent>
      <div class="menu-scroll-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <div class="menu-content">
          <srp-card subtitle="{{(pageContentLabels | contentFilter: LABELS.FAVOURITES) || 'Favourites'}}"
            class="favourite-card">
            @if(!loaded()) {
              <div>
                <p class="errorMsg">
                  {{(pageContentLabels | contentFilter: LABELS.FAVS_FAILED) || 'Failed to load. Please try again later.'}}
                </p>
              </div>

            } @else {
              <div>
                @if (favorites().length) {
                  <span>
                    @for (fav of favorites(); track fav; let favIndex = $index) {
                      @if(fav.visible) {
                      <div class="flex-dispaly srp-menu-link-container">
                        <a (click)="onLinkClick(fav)" (keydown.enter)="onLinkClick(fav)" class="srp-menu-link" [class.disabled-link]="fav.disabled">
                          {{ fav.label }}
                        </a>
                        @if (fav.label !== 'POI Link' && fav.label !== 'TI Link' && fav.name !== '491c07cd' && fav.name !== '6b283035') {
                          <srp-icon class="doNotDisturb"
                            icon="do_not_disturb_on" variant="outlined" (click)="removeFavoriteItem($event, fav, null)" (keydown.enter)="removeFavoriteItem($any($event), fav, null)" tabindex="0">
                          </srp-icon>
                        }
                      </div>
                    }
                    }
                  </span>
                }

                @if (favorites().length <= 2) {
                  <div class="fav-placeholder">
                    <img class="heart_plus_css" src="images/heart_plus.svg" alt="fav" />
                    <p>
                      {{ (pageContentLabels | contentFilter: LABELS.FAVOURITES_MESSAGE)}}
                    </p>
                  </div>
                }
              </div>
            }

          </srp-card>
        </div>
@for (parent of parentMenu(); track parent) {
  <div class="menu-content">
    <srp-card
      [subtitle]="parent.label || ''"
      variant="menu-card"
      class="mat-card-class">

      <div>

        @for (child of parent?.childMenu; track child; let childIndex = $index) {

          @if(child.visible) {

            <div class="flex-dispaly srp-menu-link-container">

              <a
                class="srp-menu-link"
                [class.disabled-link]="child.disabled"
                (click)="child.childMenu?.length ? toggleSubmenu(child, $any($event)) : onLinkClick(child)"
                (keydown.enter)="child.childMenu?.length ? toggleSubmenu(child, $any($event)) : onLinkClick(child)">

                {{ child.label }}

              </a>
              @if(child?.childMenu?.length==0) {
                <srp-icon
                icon="favorite"
                [class]="child.isFavorite ? 'iconStyleFav' : 'iconStyle'"
                (click)="child.isFavorite ? removeFavoriteItem($event, child, parent.label) : addFavoriteItem($event, child, parent.label)"
                (keydown.enter)="child.isFavorite ? removeFavoriteItem($any($event), child, parent.label) : addFavoriteItem($any($event), child, parent.label)"
                tabindex="0">
              </srp-icon>
              }
              

              @if (child.childMenu?.length) {
                <srp-icon
                  class="expand-icon"
                  [icon]="isSubmenuOpen(child) ? 'expand_less' : 'expand_more'"
                  (click)="toggleSubmenu(child, $any($event))"
                  tabindex="0">
                </srp-icon>
              }

            </div>

            @if (child.childMenu?.length && isSubmenuOpen(child)) {

              <div class="sub-menu-list">

                @for (group of child.childMenu; track group) {

                    <div class="flex-dispaly srp-menu-link-container">

                      <a
                        class="srp-submenu-link"
                        [class.disabled-link]="group.disabled"
                        (click)="onSublevelClick(group)"
                        (keydown.enter)="onSublevelClick(group)"
                        tabindex="0">

                        {{
                          group.label
                        }}

                      </a>
                   <srp-icon

                icon="favorite"

                [class]="group.isFavorite ? 'iconStyleFav' : 'iconStyle'"

                (click)="group.isFavorite ? removeFavoriteItem($event, group, parent.label) : addFavoriteItem($event, group, parent.label)"

                (keydown.enter)="group.isFavorite ? removeFavoriteItem($any($event), group, parent.label) : addFavoriteItem($any($event), group, parent.label)"

                tabindex="0">
                </srp-icon>

                    </div>

                }

              </div>

            }

          }

        }

      </div>

    </srp-card>
  </div>
}
      </div>
    </ng-template>
  </mat-menu>
  </div>
